var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import Recognition from "./secondaryNavContexts/Recognition";
import Admin from "./secondaryNavContexts/Admin";
import Medical from "./secondaryNavContexts/Medical";
var SecondaryNavContext = /** @class */ (function (_super) {
    __extends(SecondaryNavContext, _super);
    function SecondaryNavContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecondaryNavContext.prototype.render = function () {
        var pathname = this.props.pathname;
        var _a = this.context, apps = _a.apps, appPath = _a.appPath;
        switch (appPath) {
            case apps.RECOGNITION:
                return React.createElement(Recognition, { pathname: pathname });
            case apps.ADMIN:
                return React.createElement(Admin, { pathname: pathname });
            case apps.MEDICAL:
                return React.createElement(Medical, { pathname: pathname });
            default:
                return null;
        }
    };
    SecondaryNavContext.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    SecondaryNavContext.defaultProps = {
        pathname: ""
    };
    return SecondaryNavContext;
}(PureComponent));
export default SecondaryNavContext;
